import { Directive, HostBinding, inject } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';

/**
 * Maybe the mat-form-field will provide this sometime in the future
 * https://github.com/angular/components/issues/15809
 */
@Directive({
    selector: 'mat-form-field[redispatchProvideReadonly]',
    standalone: false,
})
export class MatFormFieldProvideReadonlyDirective {

    private _matFormField = inject(MatFormField);

    @HostBinding('class.mat-form-field-readonly') get isReadonly() {
        const ctrl = this._matFormField._control;
        return ctrl && 'readonly' in ctrl ? ctrl['readonly'] : false;
    }
}
